var map = {
	"./images/all-star/brushes/abbie.png": 824,
	"./images/all-star/brushes/enrique.png": 825,
	"./images/all-star/brushes/gabi.png": 826,
	"./images/all-star/brushes/ian.png": 827,
	"./images/all-star/brushes/jimmy.png": 828,
	"./images/all-star/brushes/karin.png": 829,
	"./images/all-star/brushes/lisa.png": 830,
	"./images/all-star/brushes/max.png": 831,
	"./images/all-star/brushes/mikko.png": 832,
	"./images/all-star/brushes/nikko.png": 833,
	"./images/all-star/brushes/stefan.png": 834,
	"./images/all-star/brushes/tip-top.png": 835,
	"./images/all-star/button-bg.jpg": 270,
	"./images/all-star/button-left.png": 836,
	"./images/all-star/button-right.png": 837,
	"./images/all-star/hero-vid-poster_cn.jpg": 838,
	"./images/all-star/hero-vid-poster_en.jpg": 839,
	"./images/alter-ego/alter-ego-hero_cn.png": 840,
	"./images/alter-ego/alter-ego-hero_en.png": 841,
	"./images/alter-ego/alter-ego-hero_jp.png": 842,
	"./images/alter-ego/alter-ego-palette_cn.jpg": 843,
	"./images/alter-ego/alter-ego-palette_en.jpg": 844,
	"./images/alter-ego/alter-ego-palette_jp.jpg": 845,
	"./images/artprize/ap2020-result-logo-cn.png": 846,
	"./images/artprize/ap2020-result-logo.png": 847,
	"./images/artprize/ap2020-watermark-cn.png": 848,
	"./images/artprize/ap2020-watermark.png": 849,
	"./images/artprize/devs-choice-cn.png": 850,
	"./images/artprize/devs-choice.png": 851,
	"./images/artprize/grand-prize-cn.png": 852,
	"./images/artprize/grand-prize.png": 853,
	"./images/artprize/logo.png": 272,
	"./images/artprize/second-prize-cn.png": 854,
	"./images/artprize/second-prize.png": 855,
	"./images/artprize/student-grand-prize-cn.png": 856,
	"./images/artprize/student-grand-prize.png": 857,
	"./images/artprize/student-second-prize-cn.png": 858,
	"./images/artprize/student-second-prize.png": 859,
	"./images/artprize/waterfall-mask-image-cn.png": 274,
	"./images/artprize/waterfall-mask-image-en.png": 273,
	"./images/artprize/works-we-love-cn.png": 860,
	"./images/artprize/works-we-love.png": 861,
	"./images/badges/ada-badge-2013_cn.svg": 862,
	"./images/badges/ada-badge-2013_en.svg": 863,
	"./images/badges/ada-badge-2013_jp.svg": 864,
	"./images/badges/ada-badge-2022_cn.svg": 865,
	"./images/badges/ada-badge-2022_en.svg": 866,
	"./images/badges/ada-badge-2022_jp.svg": 867,
	"./images/badges/iphone-aoty-2018-dark_cn.svg": 868,
	"./images/badges/iphone-aoty-2018_en.svg": 869,
	"./images/badges/iphone-aoty-2018_jp.svg": 870,
	"./images/beginners-series/part-four-thumb.jpg": 871,
	"./images/beginners-series/part-four-thumb_mobile.jpg": 872,
	"./images/beginners-series/part-one-thumb.jpg": 873,
	"./images/beginners-series/part-one-thumb_mobile.jpg": 874,
	"./images/beginners-series/part-three-thumb.jpg": 875,
	"./images/beginners-series/part-three-thumb_mobile.jpg": 876,
	"./images/beginners-series/part-two-thumb.jpg": 877,
	"./images/beginners-series/part-two-thumb_mobile.jpg": 878,
	"./images/beginners-series/play.svg": 879,
	"./images/beginners-series/squig1.png": 880,
	"./images/beginners-series/squig2-2.png": 881,
	"./images/beginners-series/squig3.png": 882,
	"./images/beginners-series/squig4.png": 883,
	"./images/credit-thumbnails/ipad/aaron-griffin-neon.jpg": 884,
	"./images/credit-thumbnails/ipad/aaron-griffin-sketch-series-1.jpg": 885,
	"./images/credit-thumbnails/ipad/aaron-griffin-sketch-series.jpg": 886,
	"./images/credit-thumbnails/ipad/aaron-griffin-untitled.jpg": 887,
	"./images/credit-thumbnails/ipad/acky-bright-attack.jpg": 888,
	"./images/credit-thumbnails/ipad/agiel-untitled.jpg": 889,
	"./images/credit-thumbnails/ipad/al-jerek-torrijas-saved-by-the-bell.jpg": 890,
	"./images/credit-thumbnails/ipad/alexis-franklin-untitled-2.jpg": 891,
	"./images/credit-thumbnails/ipad/alexis-franklin-untitled.jpg": 892,
	"./images/credit-thumbnails/ipad/andrew-pena-echo-park.jpg": 893,
	"./images/credit-thumbnails/ipad/andrew-pena-san-gabriele-canyon.jpg": 894,
	"./images/credit-thumbnails/ipad/andrey-malykh-untitled.jpg": 895,
	"./images/credit-thumbnails/ipad/angela-sung-car.jpg": 896,
	"./images/credit-thumbnails/ipad/angela-sung-light-and-dark.jpg": 897,
	"./images/credit-thumbnails/ipad/angela-sung-pasadena.jpg": 898,
	"./images/credit-thumbnails/ipad/angela-sung-tramline.jpg": 899,
	"./images/credit-thumbnails/ipad/arash-razavi-tawny.jpg": 900,
	"./images/credit-thumbnails/ipad/arnandhita-agiel-untitled.jpg": 901,
	"./images/credit-thumbnails/ipad/asli-narin-untitled.jpg": 902,
	"./images/credit-thumbnails/ipad/asuka111-geisha.jpg": 903,
	"./images/credit-thumbnails/ipad/asuka111-glitch.jpg": 904,
	"./images/credit-thumbnails/ipad/asuka111-the-cat-caravan.jpg": 905,
	"./images/credit-thumbnails/ipad/ayan-nag-hut.jpg": 906,
	"./images/credit-thumbnails/ipad/ayan-nag-midnight-gleam.jpg": 907,
	"./images/credit-thumbnails/ipad/ayan-nag-red-sand.jpg": 908,
	"./images/credit-thumbnails/ipad/ayan-nag-valley.jpg": 909,
	"./images/credit-thumbnails/ipad/ayan_nag-frosty-glaze.jpg": 910,
	"./images/credit-thumbnails/ipad/bastien-grivet-the-door.jpg": 911,
	"./images/credit-thumbnails/ipad/chelsea-blecha-bungalow.jpg": 912,
	"./images/credit-thumbnails/ipad/christiane-king-another-untitled.jpg": 913,
	"./images/credit-thumbnails/ipad/christiane-king-untitled.jpg": 914,
	"./images/credit-thumbnails/ipad/christiane-king-working-portrait.jpg": 915,
	"./images/credit-thumbnails/ipad/dani-diez-desert-seeker.jpg": 916,
	"./images/credit-thumbnails/ipad/danni-fisher-shin-reality-filter.jpg": 917,
	"./images/credit-thumbnails/ipad/deborah-lee-untitled.jpg": 918,
	"./images/credit-thumbnails/ipad/donglongdong-wondertown.jpg": 919,
	"./images/credit-thumbnails/ipad/eliza-ivanova-untitled.jpg": 920,
	"./images/credit-thumbnails/ipad/enrique-figueroa-princess-uakamayatl.jpg": 921,
	"./images/credit-thumbnails/ipad/even-amundsen-the_deepwoods.jpg": 922,
	"./images/credit-thumbnails/ipad/even-amundsen-untitled.jpg": 923,
	"./images/credit-thumbnails/ipad/fatemeh-haghnejad-explorers.jpeg": 924,
	"./images/credit-thumbnails/ipad/giles-ketting-unknown.jpg": 925,
	"./images/credit-thumbnails/ipad/godwin-akpan-all-a-blur.jpg": 926,
	"./images/credit-thumbnails/ipad/goro-fujita-enoki-tales.jpg": 927,
	"./images/credit-thumbnails/ipad/guangyuan-beast.jpg": 928,
	"./images/credit-thumbnails/ipad/ilya-kuvshinov-fox.jpg": 929,
	"./images/credit-thumbnails/ipad/ilya-kuvshinov-untitled.jpg": 930,
	"./images/credit-thumbnails/ipad/ivan-belikov-guitar.jpg": 931,
	"./images/credit-thumbnails/ipad/ivan-belikov-parus.jpg": 932,
	"./images/credit-thumbnails/ipad/jarom-vogel-monkey.jpg": 933,
	"./images/credit-thumbnails/ipad/jarom-vogel-natures-dance.jpg": 934,
	"./images/credit-thumbnails/ipad/jarom-vogel-untitled.jpg": 935,
	"./images/credit-thumbnails/ipad/jaye-kang-secret-of-foxes.jpg": 936,
	"./images/credit-thumbnails/ipad/jaye-kang-xuanwu.jpg": 937,
	"./images/credit-thumbnails/ipad/jhonny-nunez-desert.jpg": 938,
	"./images/credit-thumbnails/ipad/kael-escape.jpg": 939,
	"./images/credit-thumbnails/ipad/lois-van-baarle-petals.jpg": 940,
	"./images/credit-thumbnails/ipad/marija-tiurina-the-breakfast-cart.jpg": 941,
	"./images/credit-thumbnails/ipad/max-ulichney-believers.jpg": 942,
	"./images/credit-thumbnails/ipad/max-ulichney-scuba.jpg": 943,
	"./images/credit-thumbnails/ipad/michal-sawtyruk-day-out.jpg": 944,
	"./images/credit-thumbnails/ipad/micheal-relth-little-birdy.jpg": 945,
	"./images/credit-thumbnails/ipad/mike-mccain-adventure-bound.jpg": 946,
	"./images/credit-thumbnails/ipad/mingjue-helen-chen-parkillo.jpg": 947,
	"./images/credit-thumbnails/ipad/mohammed-fazil-shoe.jpg": 948,
	"./images/credit-thumbnails/ipad/nick-liefhebber-creativity-and-the-arts.jpg": 949,
	"./images/credit-thumbnails/ipad/nick-liefhebber-wild-flower.jpg": 950,
	"./images/credit-thumbnails/ipad/nikko-80s.jpg": 951,
	"./images/credit-thumbnails/ipad/nikolai-lockertsen-office-field-of-dreams.jpg": 952,
	"./images/credit-thumbnails/ipad/nikolai-lockertsen-office.jpg": 953,
	"./images/credit-thumbnails/ipad/nikolai-lockertsen-river-view.jpg": 954,
	"./images/credit-thumbnails/ipad/nikolai-lockertsen-transendence.jpg": 955,
	"./images/credit-thumbnails/ipad/nikolai-lockertsen-walk-the-dog.jpg": 956,
	"./images/credit-thumbnails/ipad/nuwarhol-untitled.jpg": 957,
	"./images/credit-thumbnails/ipad/patrick-okeefe-running-late.jpg": 958,
	"./images/credit-thumbnails/ipad/pauline-vos-the-kiss.jpg": 959,
	"./images/credit-thumbnails/ipad/pauline-vos-untitled.jpg": 960,
	"./images/credit-thumbnails/ipad/rebecca-mills-little-help.jpg": 961,
	"./images/credit-thumbnails/ipad/rune-fisker-dearly-departed.jpg": 962,
	"./images/credit-thumbnails/ipad/sam-nassour-untitled.jpg": 963,
	"./images/credit-thumbnails/ipad/sam-rodriguez-nectar.jpg": 964,
	"./images/credit-thumbnails/ipad/sam-rodriguez-untitled.jpg": 965,
	"./images/credit-thumbnails/ipad/sam-rodriquez-skateboard.jpg": 966,
	"./images/credit-thumbnails/ipad/sam-rodriquez-untitled-2.jpg": 967,
	"./images/credit-thumbnails/ipad/sami-halim-jungle.jpg": 968,
	"./images/credit-thumbnails/ipad/sang-wook-kim-the-danced-all-night.jpg": 969,
	"./images/credit-thumbnails/ipad/saroush-barazesh-kings-of-nowhere.jpg": 970,
	"./images/credit-thumbnails/ipad/satoma-untitled.jpg": 971,
	"./images/credit-thumbnails/ipad/sau-koinobori.jpg": 972,
	"./images/credit-thumbnails/ipad/sean-edwards-entourage.jpg": 973,
	"./images/credit-thumbnails/ipad/shannon-king-together-we-rise.jpg": 974,
	"./images/credit-thumbnails/ipad/stephane-bourez-alien-panther.jpg": 975,
	"./images/credit-thumbnails/ipad/stephane-bourez-escapee.jpg": 976,
	"./images/credit-thumbnails/ipad/stephane-bourez-forest-discovery.jpg": 977,
	"./images/credit-thumbnails/ipad/stephane-bourez-mech.jpg": 978,
	"./images/credit-thumbnails/ipad/tom-everingham-cut-out.jpg": 979,
	"./images/credit-thumbnails/ipad/wanjie-li-untitled.jpg": 980,
	"./images/credit-thumbnails/ipad/will-robinson-old-mage.jpg": 981,
	"./images/credit-thumbnails/ipad/will-robinson-rampage.jpg": 982,
	"./images/credit-thumbnails/ipad/zutto-evolution.jpg": 983,
	"./images/credit-thumbnails/ipad/zutto-fizzy.jpg": 984,
	"./images/credit-thumbnails/ipad/zutto-the-wave.jpg": 985,
	"./images/credit-thumbnails/pocket/127-lion-dance-lying-down.jpg": 986,
	"./images/credit-thumbnails/pocket/aaron-griffin-drift.jpg": 987,
	"./images/credit-thumbnails/pocket/andrew-pena-big-bear-trees.jpg": 988,
	"./images/credit-thumbnails/pocket/andrew-pena-descanso-creek.jpg": 989,
	"./images/credit-thumbnails/pocket/angela-sung-in-the-garden.jpg": 990,
	"./images/credit-thumbnails/pocket/angela-sung-on-tokyo-streets.jpg": 991,
	"./images/credit-thumbnails/pocket/asuka111-koi.jpg": 992,
	"./images/credit-thumbnails/pocket/dani-diez-untitled.jpg": 993,
	"./images/credit-thumbnails/pocket/danni-fisher-shin-lone-warrior.jpg": 994,
	"./images/credit-thumbnails/pocket/goro-fujita-the-lantern-maker.jpg": 995,
	"./images/credit-thumbnails/pocket/janice-sung-lush.jpg": 996,
	"./images/credit-thumbnails/pocket/jarom-vogel-powerful-stuff.jpg": 997,
	"./images/credit-thumbnails/pocket/jaye-kang-be-special.jpg": 998,
	"./images/credit-thumbnails/pocket/jaye-kang-flower-maker.jpg": 999,
	"./images/credit-thumbnails/pocket/max-ulichney-caldera.jpg": 1000,
	"./images/credit-thumbnails/pocket/monez-guzmang-early-bird.jpg": 1001,
	"./images/credit-thumbnails/pocket/nick-liefhebber-leaving-home.jpg": 1002,
	"./images/credit-thumbnails/pocket/nick-liefhebber-the-galaxy-knows.jpg": 1003,
	"./images/credit-thumbnails/pocket/randy-barias-untitled.jpg": 1004,
	"./images/credit-thumbnails/pocket/rebecca-mills-hello-fish-friends.jpg": 1005,
	"./images/credit-thumbnails/pocket/samy-halim-martin-day.jpg": 1006,
	"./images/credit-thumbnails/pocket/samy-halim-martin-night.jpg": 1007,
	"./images/credit-thumbnails/pocket/sara-lee-chromatic-jungle.jpg": 1008,
	"./images/credit-thumbnails/pocket/siyi-chen-im-feline-fine.jpg": 1009,
	"./images/credit-thumbnails/pocket/siyi-chen-sun-shower.jpg": 1010,
	"./images/credit-thumbnails/pocket/zutto-new-places.jpg": 1011,
	"./images/credit-thumbnails/pocket/zutto-pink-dragons.jpg": 1012,
	"./images/employment/cluster1.jpg": 1013,
	"./images/employment/cluster2.jpg": 1014,
	"./images/employment/cluster3.jpg": 1015,
	"./images/employment/tassie1.jpg": 1016,
	"./images/employment/tassie2.jpg": 1017,
	"./images/employment/tassie3.jpg": 1018,
	"./images/favicon/android-icon-144x144.png": 1019,
	"./images/favicon/android-icon-192x192.png": 1020,
	"./images/favicon/android-icon-36x36.png": 1021,
	"./images/favicon/android-icon-48x48.png": 1022,
	"./images/favicon/android-icon-72x72.png": 1023,
	"./images/favicon/android-icon-96x96.png": 1024,
	"./images/favicon/apple-icon-114x114.png": 1025,
	"./images/favicon/apple-icon-120x120.png": 1026,
	"./images/favicon/apple-icon-152x152.png": 1027,
	"./images/favicon/apple-icon-57x57.png": 1028,
	"./images/favicon/apple-icon-60x60.png": 1029,
	"./images/favicon/apple-icon-72x72.png": 1030,
	"./images/favicon/apple-icon-76x76.png": 1031,
	"./images/favicon/apple-icon-precomposed.png": 1032,
	"./images/favicon/apple-icon.png": 1033,
	"./images/favicon/favicon-16x16.png": 1034,
	"./images/favicon/favicon-32x32.png": 1035,
	"./images/favicon/favicon-96x96.png": 1036,
	"./images/favicon/favicon.ico": 1037,
	"./images/favicon/manifest": 286,
	"./images/favicon/manifest.json": 286,
	"./images/favicon/ms-icon-144x144.png": 1038,
	"./images/favicon/ms-icon-150x150.png": 1039,
	"./images/favicon/ms-icon-310x310.png": 1040,
	"./images/favicon/ms-icon-70x70.png": 1041,
	"./images/flags/en-US.png": 1042,
	"./images/flags/ja.png": 1043,
	"./images/flags/zh-CN.png": 1044,
	"./images/handbook/handbook-explosion_cn.jpg": 1045,
	"./images/handbook/handbook-explosion_en.jpg": 1046,
	"./images/handbook/handbook-explosion_jp.jpg": 1047,
	"./images/home/masonry/a11y-mobile.jpg": 1048,
	"./images/home/masonry/a11y.jpg": 1049,
	"./images/home/masonry/alter-ego-mobile_en.jpg": 1050,
	"./images/home/masonry/alter-ego-tablet_en.jpg": 1051,
	"./images/home/masonry/alter-ego_en.jpg": 1052,
	"./images/home/masonry/brushes-mobile_cn.jpg": 1053,
	"./images/home/masonry/brushes-mobile_en.jpg": 1054,
	"./images/home/masonry/brushes-mobile_jp.jpg": 1055,
	"./images/home/masonry/brushes-tablet_cn.jpg": 1056,
	"./images/home/masonry/brushes-tablet_en.jpg": 1057,
	"./images/home/masonry/brushes-tablet_jp.jpg": 1058,
	"./images/home/masonry/brushes_cn.jpg": 1059,
	"./images/home/masonry/brushes_en.jpg": 1060,
	"./images/home/masonry/brushes_jp.jpg": 1061,
	"./images/home/masonry/careers-tile-mobile.jpg": 1062,
	"./images/home/masonry/careers-tile.jpg": 1063,
	"./images/home/masonry/edu-tablet.jpg": 1064,
	"./images/home/masonry/education-mobile.jpg": 1065,
	"./images/home/masonry/education.jpg": 1066,
	"./images/home/masonry/folio-mobile.jpg": 1067,
	"./images/home/masonry/folio-tablet.jpg": 1068,
	"./images/home/masonry/folio.jpg": 1069,
	"./images/home/masonry/ipad-mobile_cn.jpg": 1070,
	"./images/home/masonry/ipad-mobile_en.jpg": 1071,
	"./images/home/masonry/ipad-mobile_jp.jpg": 1072,
	"./images/home/masonry/ipad_cn.jpg": 1073,
	"./images/home/masonry/ipad_en.jpg": 1074,
	"./images/home/masonry/ipad_jp.jpg": 1075,
	"./images/home/masonry/pocket-mobile_cn.jpg": 1076,
	"./images/home/masonry/pocket-mobile_en.jpg": 1077,
	"./images/home/masonry/pocket-mobile_jp.jpg": 1078,
	"./images/home/masonry/pocket-tablet_cn.jpg": 1079,
	"./images/home/masonry/pocket-tablet_en.jpg": 1080,
	"./images/home/masonry/pocket-tablet_jp.jpg": 1081,
	"./images/home/masonry/pocket_cn.jpg": 1082,
	"./images/home/masonry/pocket_en.jpg": 1083,
	"./images/home/masonry/pocket_jp.jpg": 1084,
	"./images/home/masonry/whats-new-desktop_cn.jpg": 1085,
	"./images/home/masonry/whats-new-desktop_en.jpg": 1086,
	"./images/home/masonry/whats-new-desktop_jp.jpg": 1087,
	"./images/home/masonry/whats-new-mobile_cn.jpg": 1088,
	"./images/home/masonry/whats-new-mobile_en.jpg": 1089,
	"./images/home/masonry/whats-new-mobile_jp.jpg": 1090,
	"./images/home/procreate-53-frame.png": 259,
	"./images/ipad/3d/ar-view.jpg": 1091,
	"./images/ipad/3d/ar-view_blur.jpg": 1092,
	"./images/ipad/3d/lighting-studio_cn.jpg": 1093,
	"./images/ipad/3d/lighting-studio_en.jpg": 1094,
	"./images/ipad/3d/lighting-studio_jp.jpg": 1095,
	"./images/ipad/3d/materials-2_cn.jpg": 1096,
	"./images/ipad/3d/materials-2_en.jpg": 1097,
	"./images/ipad/3d/materials-2_jp.jpg": 1098,
	"./images/ipad/3d/materials_cn.jpg": 1099,
	"./images/ipad/3d/materials_en.jpg": 1100,
	"./images/ipad/3d/materials_jp.jpg": 1101,
	"./images/ipad/a11y-cta-bg.jpg": 260,
	"./images/ipad/a11y/a11y-color-naming-1_cn.jpg": 1102,
	"./images/ipad/a11y/a11y-color-naming-1_en.jpg": 1103,
	"./images/ipad/a11y/a11y-color-naming-1_jp.jpg": 1104,
	"./images/ipad/a11y/a11y-large-text-1_cn.jpg": 1105,
	"./images/ipad/a11y/a11y-large-text-1_en.jpg": 1106,
	"./images/ipad/a11y/a11y-large-text-1_jp.jpg": 1107,
	"./images/ipad/a11y/a11y-onionskin_cn.jpg": 1108,
	"./images/ipad/a11y/a11y-onionskin_en.jpg": 1109,
	"./images/ipad/a11y/a11y-onionskin_jp.jpg": 1110,
	"./images/ipad/a11y/a11y-stability-1_cn.jpg": 1111,
	"./images/ipad/a11y/a11y-stability-1_en.jpg": 1112,
	"./images/ipad/a11y/a11y-stability-1_jp.jpg": 1113,
	"./images/ipad/a11y/a11y-stability-2_cn.jpg": 1114,
	"./images/ipad/a11y/a11y-stability-2_en.jpg": 1115,
	"./images/ipad/a11y/a11y-stability-2_jp.jpg": 1116,
	"./images/ipad/a11y/a11y-support_cn.jpg": 1117,
	"./images/ipad/a11y/a11y-support_en.jpg": 1118,
	"./images/ipad/a11y/a11y-support_jp.jpg": 1119,
	"./images/ipad/brush-studio_cn.jpg": 1120,
	"./images/ipad/brush-studio_en.jpg": 1121,
	"./images/ipad/brush-studio_jp.jpg": 1122,
	"./images/ipad/brushes/abr_cn.jpg": 1123,
	"./images/ipad/brushes/abr_en.jpg": 1124,
	"./images/ipad/brushes/abr_jp.jpg": 1125,
	"./images/ipad/brushes/brushes-cn-2.jpg": 1126,
	"./images/ipad/brushes/brushes-cn-3.jpg": 1127,
	"./images/ipad/brushes/brushes-cn-5.jpg": 1128,
	"./images/ipad/brushes/brushes-cn-hero.jpg": 1129,
	"./images/ipad/brushes/brushes-en-3.jpg": 1130,
	"./images/ipad/brushes/brushes-en-4.jpg": 1131,
	"./images/ipad/brushes/brushes-en-6.jpg": 1132,
	"./images/ipad/brushes/brushes-en-hero.jpg": 1133,
	"./images/ipad/brushes/brushes-jp-2.jpg": 1134,
	"./images/ipad/brushes/brushes-jp-3.jpg": 1135,
	"./images/ipad/brushes/brushes-jp-4.jpg": 1136,
	"./images/ipad/brushes/brushes-jp-hero.jpg": 1137,
	"./images/ipad/brushes/brushes-left_cn.jpg": 1138,
	"./images/ipad/brushes/brushes-left_en.jpg": 1139,
	"./images/ipad/brushes/brushes-left_jp.jpg": 1140,
	"./images/ipad/brushes/make-brushes-1_cn.jpg": 1141,
	"./images/ipad/brushes/make-brushes-1_en.jpg": 1142,
	"./images/ipad/brushes/make-brushes-1_jp.jpg": 1143,
	"./images/ipad/brushes/make-brushes-2_cn.jpg": 1144,
	"./images/ipad/brushes/make-brushes-2_en.jpg": 1145,
	"./images/ipad/brushes/make-brushes-2_jp.jpg": 1146,
	"./images/ipad/color/color-balance_cn.jpg": 1147,
	"./images/ipad/color/color-balance_en.jpg": 1148,
	"./images/ipad/color/color-balance_jp.jpg": 1149,
	"./images/ipad/color/color-companion-1_cn.jpg": 1150,
	"./images/ipad/color/color-companion-1_en.jpg": 1151,
	"./images/ipad/color/color-companion-1_jp.jpg": 1152,
	"./images/ipad/color/color-companion-2_cn.jpg": 1153,
	"./images/ipad/color/color-companion-2_en.jpg": 1154,
	"./images/ipad/color/color-companion-2_jp.jpg": 1155,
	"./images/ipad/color/color-dynamics-1_cn.jpg": 1156,
	"./images/ipad/color/color-dynamics-1_en.jpg": 1157,
	"./images/ipad/color/color-dynamics-1_jp.jpg": 1158,
	"./images/ipad/color/color-dynamics-2_cn.jpg": 1159,
	"./images/ipad/color/color-dynamics-2_en.jpg": 1160,
	"./images/ipad/color/color-dynamics-2_jp.jpg": 1161,
	"./images/ipad/color/palette-1-bg.jpg": 1162,
	"./images/ipad/color/palette-1_fg_cn.jpg": 1163,
	"./images/ipad/color/palette-1_fg_en.jpg": 1164,
	"./images/ipad/color/palette-1_fg_jp.jpg": 1165,
	"./images/ipad/color/palette-2-bg.jpg": 1166,
	"./images/ipad/color/palette-2_fg_cn.jpg": 1167,
	"./images/ipad/color/palette-2_fg_en.jpg": 1168,
	"./images/ipad/color/palette-2_fg_jp.jpg": 1169,
	"./images/ipad/color/palettes_cn.jpg": 1170,
	"./images/ipad/color/palettes_en.jpg": 1171,
	"./images/ipad/color/palettes_jp.jpg": 1172,
	"./images/ipad/cutting-edge/boundingbox_cn.jpg": 1173,
	"./images/ipad/cutting-edge/boundingbox_en.jpg": 1174,
	"./images/ipad/cutting-edge/boundingbox_jp.jpg": 1175,
	"./images/ipad/cutting-edge/cutting-edge-cn-3.jpg": 1176,
	"./images/ipad/cutting-edge/cutting-edge-en-3.jpg": 1177,
	"./images/ipad/cutting-edge/cutting-edge-jp-3.jpg": 1178,
	"./images/ipad/cutting-edge/pencil-filter-left_cn.jpg": 1179,
	"./images/ipad/cutting-edge/pencil-filter-left_en.jpg": 1180,
	"./images/ipad/cutting-edge/pencil-filter-left_jp.jpg": 1181,
	"./images/ipad/cutting-edge/pencil-filter-right_cn.jpg": 1182,
	"./images/ipad/cutting-edge/pencil-filter-right_en.jpg": 1183,
	"./images/ipad/cutting-edge/pencil-filter-right_jp.jpg": 1184,
	"./images/ipad/cutting-edge/quickmenu_cn.jpg": 1185,
	"./images/ipad/cutting-edge/quickmenu_en.jpg": 1186,
	"./images/ipad/cutting-edge/quickmenu_jp.jpg": 1187,
	"./images/ipad/cutting-edge/streamline_cn.jpg": 1188,
	"./images/ipad/cutting-edge/streamline_en.jpg": 1189,
	"./images/ipad/cutting-edge/streamline_jp.jpg": 1190,
	"./images/ipad/cutting-edge/symmetry_cn.jpg": 1191,
	"./images/ipad/cutting-edge/symmetry_en.jpg": 1192,
	"./images/ipad/cutting-edge/symmetry_jp.jpg": 1193,
	"./images/ipad/facepaint-1_cn.jpg": 1194,
	"./images/ipad/facepaint-1_en.jpg": 1195,
	"./images/ipad/facepaint-1_jp.jpg": 1196,
	"./images/ipad/facepaint-4_cn.jpg": 1197,
	"./images/ipad/facepaint-4_en.jpg": 1198,
	"./images/ipad/facepaint-4_jp.jpg": 1199,
	"./images/ipad/fontcontrol_cn.jpg": 1200,
	"./images/ipad/fontcontrol_en.jpg": 1201,
	"./images/ipad/fontcontrol_jp.jpg": 1202,
	"./images/ipad/frames/ipad-frame-landscape.png": 250,
	"./images/ipad/frames/ipad-frame-portrait.png": 253,
	"./images/ipad/frames/ipad-sm-frame-landscape.png": 255,
	"./images/ipad/frames/ipad-sm-frame-portrait.png": 257,
	"./images/ipad/ideation-1_cn.jpg": 1203,
	"./images/ipad/ideation-1_en.jpg": 1204,
	"./images/ipad/ideation-1_jp.jpg": 1205,
	"./images/ipad/ideation-2_cn.jpg": 1206,
	"./images/ipad/ideation-2_en.jpg": 1207,
	"./images/ipad/ideation-2_jp.jpg": 1208,
	"./images/ipad/ipad-brush-diagram.jpg": 1209,
	"./images/ipad/ipad-cn-11.jpg": 1210,
	"./images/ipad/ipad-cn-13.jpg": 1211,
	"./images/ipad/ipad-cn-2.jpg": 1212,
	"./images/ipad/ipad-cn-3.jpg": 1213,
	"./images/ipad/ipad-en-11.jpg": 1214,
	"./images/ipad/ipad-en-13.jpg": 1215,
	"./images/ipad/ipad-en-2.jpg": 1216,
	"./images/ipad/ipad-en-3.jpg": 1217,
	"./images/ipad/ipad-gestures-1.jpg": 1218,
	"./images/ipad/ipad-gestures-2.jpg": 1219,
	"./images/ipad/ipad-gestures-3.jpg": 1220,
	"./images/ipad/ipad-jp-11.jpg": 1221,
	"./images/ipad/ipad-jp-13.jpg": 1222,
	"./images/ipad/ipad-jp-2.jpg": 1223,
	"./images/ipad/ipad-jp-3.jpg": 1224,
	"./images/ipad/placeholder-landscape.jpg": 1225,
	"./images/ipad/placeholder-portrait.jpg": 1226,
	"./images/ipad/shadows/shadow-landscape.png": 251,
	"./images/ipad/shadows/shadow-portrait.png": 254,
	"./images/ipad/shadows/shadow-pro-landscape-soft.png": 252,
	"./images/ipad/shadows/shadow-sm-landscape-150.png": 256,
	"./images/ipad/shadows/shadow-sm-landscape.png": 1227,
	"./images/ipad/shadows/shadow-sm-portrait-150.png": 258,
	"./images/ipad/specialeffects-1_cn.jpg": 1228,
	"./images/ipad/specialeffects-1_en.jpg": 1229,
	"./images/ipad/specialeffects-1_jp.jpg": 1230,
	"./images/ipad/specialeffects-2_cn.jpg": 1231,
	"./images/ipad/specialeffects-2_en.jpg": 1232,
	"./images/ipad/specialeffects-2_jp.jpg": 1233,
	"./images/ipad/transformselect_cn.jpg": 1234,
	"./images/ipad/transformselect_en.jpg": 1235,
	"./images/ipad/transformselect_jp.jpg": 1236,
	"./images/ipad/video/privatelayer_cn.jpg": 1237,
	"./images/ipad/video/privatelayer_en.jpg": 1238,
	"./images/ipad/video/privatelayer_jp.jpg": 1239,
	"./images/ipad/video/video-cn-1.jpg": 1240,
	"./images/ipad/video/video-en-1.jpg": 1241,
	"./images/ipad/video/video-jp-1.jpg": 1242,
	"./images/ipad/whats-new-1_cn.jpg": 1243,
	"./images/ipad/whats-new-1_en.jpg": 1244,
	"./images/ipad/whats-new-1_jp.jpg": 1245,
	"./images/ipad/whats-new-2_cn.jpg": 1246,
	"./images/ipad/whats-new-2_en.jpg": 1247,
	"./images/ipad/whats-new-2_jp.jpg": 1248,
	"./images/ipad/whats-new/hindi.svg": 1249,
	"./images/ipad/whats-new/polish.svg": 1250,
	"./images/ipad/whats-new/thai.svg": 1251,
	"./images/ipad/whats-new/whats-new-10_cn.jpg": 1252,
	"./images/ipad/whats-new/whats-new-10_en.jpg": 1253,
	"./images/ipad/whats-new/whats-new-10_jp.jpg": 1254,
	"./images/ipad/whats-new/whats-new-12_cn.jpg": 1255,
	"./images/ipad/whats-new/whats-new-12_en.jpg": 1256,
	"./images/ipad/whats-new/whats-new-12_jp.jpg": 1257,
	"./images/ipad/whats-new/whats-new-15_cn.jpg": 1258,
	"./images/ipad/whats-new/whats-new-15_en.jpg": 1259,
	"./images/ipad/whats-new/whats-new-15_jp.jpg": 1260,
	"./images/ipad/whats-new/whats-new-6_cn.jpg": 1261,
	"./images/ipad/whats-new/whats-new-6_en.jpg": 1262,
	"./images/ipad/whats-new/whats-new-6_jp.jpg": 1263,
	"./images/ipad/whats-new/whats-new-7_cn.jpg": 1264,
	"./images/ipad/whats-new/whats-new-7_en.jpg": 1265,
	"./images/ipad/whats-new/whats-new-7_jp.jpg": 1266,
	"./images/ipad/whats-new/whats-new-9_cn.jpg": 1267,
	"./images/ipad/whats-new/whats-new-9_en.jpg": 1268,
	"./images/ipad/whats-new/whats-new-9_jp.jpg": 1269,
	"./images/login-modal/login-art-1.jpg": 1270,
	"./images/login-modal/login-art-13.jpg": 1271,
	"./images/login-modal/login-art-2.jpg": 1272,
	"./images/login-modal/login-art-3.jpg": 1273,
	"./images/login-modal/login-art-4.jpg": 1274,
	"./images/login-modal/login-art-5.jpg": 1275,
	"./images/login-modal/login-art-6.jpg": 1276,
	"./images/metadata/3d_cn.jpg": 1277,
	"./images/metadata/3d_en.jpg": 1278,
	"./images/metadata/3d_jp.jpg": 1279,
	"./images/metadata/accessibility_cn.jpg": 1280,
	"./images/metadata/accessibility_en.jpg": 1281,
	"./images/metadata/accessibility_jp.jpg": 1282,
	"./images/metadata/allstar_cn.jpg": 1283,
	"./images/metadata/allstar_en.jpg": 1284,
	"./images/metadata/alter-ego_cn.jpg": 1285,
	"./images/metadata/alter-ego_en.jpg": 1286,
	"./images/metadata/alter-ego_jp.jpg": 1287,
	"./images/metadata/beginners-series.jpg": 1288,
	"./images/metadata/brushes_cn.jpg": 1289,
	"./images/metadata/brushes_en.jpg": 1290,
	"./images/metadata/brushes_jp.jpg": 1291,
	"./images/metadata/careers.jpg": 1292,
	"./images/metadata/color_cn.jpg": 1293,
	"./images/metadata/color_en.jpg": 1294,
	"./images/metadata/color_jp.jpg": 1295,
	"./images/metadata/default_cn.jpg": 1296,
	"./images/metadata/default_en.jpg": 1297,
	"./images/metadata/default_jp.jpg": 1298,
	"./images/metadata/faq_cn.jpg": 1299,
	"./images/metadata/faq_en.jpg": 1300,
	"./images/metadata/faq_jp.jpg": 1301,
	"./images/metadata/insight.jpg": 1302,
	"./images/metadata/ipad_cn.jpg": 1303,
	"./images/metadata/ipad_en.jpg": 1304,
	"./images/metadata/ipad_jp.jpg": 1305,
	"./images/metadata/og-procreate-52.jpg": 1306,
	"./images/metadata/pocket_cn.jpg": 1307,
	"./images/metadata/pocket_en.jpg": 1308,
	"./images/metadata/privacy_cn.jpg": 1309,
	"./images/metadata/privacy_en.jpg": 1310,
	"./images/metadata/privacy_jp.jpg": 1311,
	"./images/metadata/superpowers_cn.jpg": 1312,
	"./images/metadata/superpowers_en.jpg": 1313,
	"./images/metadata/superpowers_jp.jpg": 1314,
	"./images/metadata/support_cn.jpg": 1315,
	"./images/metadata/support_en.jpg": 1316,
	"./images/metadata/support_jp.jpg": 1317,
	"./images/metadata/terms_cn.jpg": 1318,
	"./images/metadata/terms_en.jpg": 1319,
	"./images/metadata/terms_jp.jpg": 1320,
	"./images/metadata/video_cn.jpg": 1321,
	"./images/metadata/video_en.jpg": 1322,
	"./images/metadata/video_jp.jpg": 1323,
	"./images/pencil/pencil-alt-attached.png": 1324,
	"./images/pencil/pencil-alt-vertical.png": 1325,
	"./images/pencil/pencil-alt.png": 1326,
	"./images/pencil/pencil-flattened.png": 1327,
	"./images/pencil/pencil-no-shadow-alt.png": 1328,
	"./images/pencil/pencil-no-shadow.png": 1329,
	"./images/pencil/pencil-shadow.png": 1330,
	"./images/pencil/pencil.png": 1331,
	"./images/pocket/animation_en.jpg": 1332,
	"./images/pocket/animation_jp.jpg": 1333,
	"./images/pocket/big-boy.jpg": 1334,
	"./images/pocket/brushes-1_en.jpg": 1335,
	"./images/pocket/brushes-1_jp.jpg": 1336,
	"./images/pocket/brushes-2_en.jpg": 1337,
	"./images/pocket/brushes-2_jp.jpg": 1338,
	"./images/pocket/cn-bg-animate.png": 1339,
	"./images/pocket/cn-bg-brushes.png": 1340,
	"./images/pocket/cn-bg-color.png": 1341,
	"./images/pocket/cn-bg-hero.png": 1342,
	"./images/pocket/cn-bg-powers.png": 1343,
	"./images/pocket/cn-bg-transform.png": 1344,
	"./images/pocket/cn_pocket-1.jpg": 1345,
	"./images/pocket/cn_pocket-10.jpg": 1346,
	"./images/pocket/cn_pocket-11.jpg": 1347,
	"./images/pocket/cn_pocket-13.jpg": 1348,
	"./images/pocket/cn_pocket-14.jpg": 1349,
	"./images/pocket/cn_pocket-15.jpg": 1350,
	"./images/pocket/cn_pocket-16.jpg": 1351,
	"./images/pocket/cn_pocket-17.jpg": 1352,
	"./images/pocket/cn_pocket-18.jpg": 1353,
	"./images/pocket/cn_pocket-19.jpg": 1354,
	"./images/pocket/cn_pocket-2.jpg": 1355,
	"./images/pocket/cn_pocket-20.jpg": 1356,
	"./images/pocket/cn_pocket-21.jpg": 1357,
	"./images/pocket/cn_pocket-22.jpg": 1358,
	"./images/pocket/cn_pocket-3.jpg": 1359,
	"./images/pocket/cn_pocket-4.jpg": 1360,
	"./images/pocket/cn_pocket-5.jpg": 1361,
	"./images/pocket/cn_pocket-6.jpg": 1362,
	"./images/pocket/cn_pocket-7.jpg": 1363,
	"./images/pocket/cn_pocket-8.jpg": 1364,
	"./images/pocket/cn_pocket-9.jpg": 1365,
	"./images/pocket/color-1_en.jpg": 1366,
	"./images/pocket/color-2_en.jpg": 1367,
	"./images/pocket/color-2_jp.jpg": 1368,
	"./images/pocket/facepaint_en.jpg": 1369,
	"./images/pocket/facepaint_jp.jpg": 1370,
	"./images/pocket/filters-flat.jpg": 1371,
	"./images/pocket/filters_en.jpg": 1372,
	"./images/pocket/filters_jp.jpg": 1373,
	"./images/pocket/footer-1_en.jpg": 1374,
	"./images/pocket/footer-1_jp.jpg": 1375,
	"./images/pocket/footer-2_en.jpg": 1376,
	"./images/pocket/footer-2_jp.jpg": 1377,
	"./images/pocket/footer-3_en.jpg": 1378,
	"./images/pocket/frame-sprites/css_sprites-left-21.png": 267,
	"./images/pocket/frame-sprites/css_sprites-left-revised.png": 1379,
	"./images/pocket/frame-sprites/css_sprites-left.png": 1380,
	"./images/pocket/frame-sprites/css_sprites-right-21.png": 266,
	"./images/pocket/frame-sprites/css_sprites-right.png": 1381,
	"./images/pocket/frame-sprites/css_sprites.png": 1382,
	"./images/pocket/hero_en.jpg": 1383,
	"./images/pocket/hero_jp.jpg": 1384,
	"./images/pocket/icon-white.png": 1385,
	"./images/pocket/interface-1_en.jpg": 1386,
	"./images/pocket/interface-1_jp.jpg": 1387,
	"./images/pocket/interface-2_en.jpg": 1388,
	"./images/pocket/interface-2_jp.jpg": 1389,
	"./images/pocket/iphone-12-pro-max-frame-landscape.png": 264,
	"./images/pocket/iphone-12-pro-max-frame.png": 262,
	"./images/pocket/iphone-12-shadow-landscape.png": 269,
	"./images/pocket/iphone-12-shadow.png": 268,
	"./images/pocket/iphone-mask-landscape.svg": 265,
	"./images/pocket/iphone-mask.svg": 263,
	"./images/pocket/iphone-x-frame.png": 1390,
	"./images/pocket/iphone-x-shadow.png": 1391,
	"./images/pocket/multiphones-flat_en.jpg": 1392,
	"./images/pocket/multiphones-flat_jp.jpg": 1393,
	"./images/pocket/palette-capture-mask.svg": 1394,
	"./images/pocket/palette-capture_en.jpg": 1395,
	"./images/pocket/palette-capture_jp.jpg": 1396,
	"./images/pocket/placeholder-landscape.jpg": 1397,
	"./images/pocket/placeholder-portrait.jpg": 1398,
	"./images/pocket/pocket-10_en.jpg": 1399,
	"./images/pocket/pocket-10_jp.jpg": 1400,
	"./images/pocket/pocket-11_en.jpg": 1401,
	"./images/pocket/pocket-11_jp.jpg": 1402,
	"./images/pocket/pocket-12_en.jpg": 1403,
	"./images/pocket/pocket-12_jp.jpg": 1404,
	"./images/pocket/pocket-13_en.jpg": 1405,
	"./images/pocket/pocket-13_jp.jpg": 1406,
	"./images/pocket/pocket-14_en.jpg": 1407,
	"./images/pocket/pocket-14_jp.jpg": 1408,
	"./images/pocket/pocket-15_en.jpg": 1409,
	"./images/pocket/pocket-15_jp.jpg": 1410,
	"./images/pocket/pocket-16_en.jpg": 1411,
	"./images/pocket/pocket-16_jp.jpg": 1412,
	"./images/pocket/pocket-17_en.jpg": 1413,
	"./images/pocket/pocket-17_jp.jpg": 1414,
	"./images/pocket/pocket-1_en.jpg": 1415,
	"./images/pocket/pocket-1_jp.jpg": 1416,
	"./images/pocket/pocket-2_en.jpg": 1417,
	"./images/pocket/pocket-2_jp.jpg": 1418,
	"./images/pocket/pocket-3_en.jpg": 1419,
	"./images/pocket/pocket-4_en.jpg": 1420,
	"./images/pocket/pocket-4_jp.jpg": 1421,
	"./images/pocket/pocket-5_en.jpg": 1422,
	"./images/pocket/pocket-5_jp.jpg": 1423,
	"./images/pocket/pocket-6_en.jpg": 1424,
	"./images/pocket/pocket-6_jp.jpg": 1425,
	"./images/pocket/pocket-7_en.jpg": 1426,
	"./images/pocket/pocket-7_jp.jpg": 1427,
	"./images/pocket/pocket-9_en.jpg": 1428,
	"./images/pocket/pocket-9_jp.jpg": 1429,
	"./images/pocket/pocket-hero-mask.svg": 261,
	"./images/press/download-tile-bg-desktop__en.jpg": 1430,
	"./images/press/download-tile-bg-mobile__en.jpg": 1431,
	"./images/press/sheila.jpg": 1432,
	"./images/resources/be-kind-background.jpg": 1433,
	"./images/resources/link-faq-desktop_en.jpg": 1434,
	"./images/resources/link-faq-mobile_en.jpg": 1435,
	"./images/resources/link-handbook-desktop_cn.jpg": 1436,
	"./images/resources/link-handbook-desktop_en.jpg": 1437,
	"./images/resources/link-handbook-desktop_jp.jpg": 1438,
	"./images/resources/link-handbook-mobile_cn.jpg": 1439,
	"./images/resources/link-handbook-mobile_en.jpg": 1440,
	"./images/resources/link-handbook-mobile_jp.jpg": 1441,
	"./images/resources/link-learn-desktop_en.jpg": 1442,
	"./images/resources/link-learn-mobile_en.jpg": 1443,
	"./images/resources/link-pocket-desktop_cn.jpg": 1444,
	"./images/resources/link-pocket-desktop_en.jpg": 1445,
	"./images/resources/link-pocket-desktop_jp.jpg": 1446,
	"./images/resources/link-pocket-mobile_cn.jpg": 1447,
	"./images/resources/link-pocket-mobile_en.jpg": 1448,
	"./images/resources/link-pocket-mobile_jp.jpg": 1449,
	"./images/resources/support-bs-cta-desktop.jpg": 1450,
	"./images/resources/support-bs-cta-mobile.jpg": 1451
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 823;